import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { createActionHandler } from '../../util';

import OmInputFieldWrapper from '../forms/OmInputFieldWrapper';
import OmDropdownField from '../forms/OmDropdownField';

import {
    setRepaymentDurationValue,
    setOtherRepaymentDurationValue,
} from '@om/redux/actions/personalLoansCalculator/calculator';
import {
    getCalculator,
    getRepaymentDuration,
    getOtherRepaymentDuration,
    getOwnRepaymentDurationMethod,
    getRepaymentDurationHintText,
} from '@om/redux/selectors/personalLoansCalculator/calculator';
import {
    getRepaymentDurationOptions,
} from '@om/redux/selectors/personalLoansCalculator/referenceData';

const RepaymentDurationForm = () => {

    const dispatch = useDispatch();

    const {
        calculator,
        repaymentDurationOptions,
        repaymentDuration,
        otherRepaymentDuration,
        ownRepaymentDurationMethod,
        repaymentDurationHintText,
    } = useSelector(
        createStructuredSelector({
            calculator: getCalculator,
            repaymentDurationOptions: getRepaymentDurationOptions,
            repaymentDuration: getRepaymentDuration,
            otherRepaymentDuration: getOtherRepaymentDuration,
            ownRepaymentDurationMethod: getOwnRepaymentDurationMethod,
            repaymentDurationHintText: getRepaymentDurationHintText,
        })
    );

    return (
        <div>
            <OmDropdownField
                useNativeMobileDropdown={true}
                placeholder="How long do you need to repay it?"
                required={true}
                id="repaymentDuration"
                formId="repaymentDurationDetailsForm"
                name="repaymentDuration"
                align="left"
                filterable={false}
                disabled={calculator.showResultsSummaryCard ? true : false}
                onSelectHandler={(event) => { dispatch(setRepaymentDurationValue(event.detail.id)) }}
                reduxValue={repaymentDuration}
                options={
                    repaymentDurationOptions && repaymentDurationOptions.map(option => ({ value: option.code, label: option.description }))
                }
            />
            {
                ownRepaymentDurationMethod !== undefined && repaymentDuration.value === ownRepaymentDurationMethod.code
                && <OmInputFieldWrapper
                    persistHandler={createActionHandler(dispatch, setOtherRepaymentDurationValue)}
                    disabled={calculator.showResultsSummaryCard ? true : false}
                    reduxValue={otherRepaymentDuration}
                    placeholder="Repayment term"
                    required="true"
                    align="left"
                    mask="thousands-spaced"
                    formId="otherLoanAmount"
                    keyboardMode="numeric"
                    hintText={repaymentDurationHintText} />
            }
        </div>
    )
}

export default RepaymentDurationForm;
